import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { HomeCategory, CATEGORY_COLORS } from '../../config/homeCategories';

interface CategoryCardProps {
  category: HomeCategory;
}

/** A single category card listing its tools — mirrors osdu-insights tiles. */
export const CategoryCard = ({ category }: CategoryCardProps) => {
  const navigate = useNavigate();
  const cc = CATEGORY_COLORS[category.color];
  const CategoryIcon = category.icon;

  const tools = category.tools;
  if (tools.length === 0) return null;

  return (
    <div className="bg-white dark:bg-gray-800/80 rounded-2xl shadow-sm dark:shadow-none dark:ring-1 dark:ring-gray-700/50 overflow-hidden">
      {/* Header */}
      <div className="px-5 py-3.5 border-b border-gray-100 dark:border-gray-700/50 flex items-center gap-2.5">
        <div className={`p-2.5 rounded-xl ${cc.iconBg} backdrop-blur-sm`}>
          <CategoryIcon className={`w-5 h-5 ${cc.iconText}`} />
        </div>
        <span className="text-base font-semibold text-gray-900 dark:text-white">{category.title}</span>
        <span className="ml-auto text-xs font-mono text-gray-400 dark:text-gray-500">{tools.length}</span>
      </div>

      {/* Tools */}
      <div className="p-2.5">
        {tools.map((tool) => {
          const ToolIcon = tool.icon;
          return (
            <button
              key={tool.id}
              onClick={() => navigate(tool.route)}
              className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left hover:bg-gray-50 dark:hover:bg-gray-700/40 hover:translate-x-0.5 transition-all duration-150 group"
            >
              <ToolIcon className={`w-5 h-5 ${cc.toolIcon} shrink-0`} />
              <span className="text-base font-medium text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-white transition-colors">
                {tool.title}
              </span>
              <ChevronRight className="w-4 h-4 text-gray-300 dark:text-gray-600 group-hover:text-gray-400 dark:group-hover:text-gray-500 transition-colors ml-auto shrink-0" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryCard;
